module.exports = __webpack_public_path__ + "img/12.ab31ac8a.png";